import { Component } from '@angular/core';
import { AppConfigService } from './shared/services/app-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private configService: AppConfigService){
    this.configService.loadCompanyConfiguration()
  }
}
